import React from 'react';

import AngleRightIcon from '../../../assets/angle-right-icon';

const Title = ({ title, subtitle, textColor = 'black', isPrimary, onClick }) => {
  const buttonColor = isPrimary ? 'text-[#049B56]' : 'text-[#FDCB2C]';
  return (
    <div className="w-[80%] m-auto my-5 space-y-3">
      <h2 className={`text-2xl md:text-4xl font-bold text-${textColor}`}>{title}</h2>
      {subtitle && <p className={`text-sm text-${textColor}`}>{subtitle}</p>}
      {onClick && (
        <button
          type="button"
          onClick={onClick}
          className="inline-flex items-center gap-2 rounded-lg text-sm px-5 py-2.5 focus:outline-none"
        >
          <span className={`${buttonColor} font-medium text-sm`}>Cek Selengkapnya</span>
          <AngleRightIcon color={isPrimary ? '#049B56' : '#FDCB2C'} />
        </button>
      )}
    </div>
  );
};

export default Title;
